export const FORMATS = {
  timeGutterFormat: "h A",
}
